function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import GlobalFooter from 'eventbrite_design_system/globalFooter/GlobalFooter';
import Illustration from 'eventbrite_design_system/illustration/Illustration';
import { LOCALES_ARRAY_PROP_TYPE, LOCALE_INFO_SHAPE_PROP_TYPE, LINKS_DATA_SHAPE_PROP_TYPE, COUNTRIES_ARRAY_PROP_TYPE, HELP_LINKS_PROP_TYPE } from './constants';
import * as utils from './utils';
import MarketingSection from './MarketingSection';
import BrandSuperCropIllustrationSvg from 'eventbrite_design_system/iconography/icons/BrandSuperCropIllustration';

var SiteFooter =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SiteFooter, _React$Component);

  function SiteFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SiteFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        thirdFooterColumn = _this$props.thirdFooterColumn,
        thirdFooterColumnName = _this$props.thirdFooterColumnName,
        eventsToPlan = _this$props.eventsToPlan,
        serverUrl = _this$props.serverUrl,
        locales = _this$props.locales,
        localeInfo = _this$props.localeInfo,
        helpLinks = _this$props.helpLinks,
        onLocaleChange = _this$props.onLocaleChange,
        popularSearches = _this$props.popularSearches,
        showBrand = _this$props.showBrand,
        showMinimalLinks = _this$props.showMinimalLinks,
        showMarketingLinks = _this$props.showMarketingLinks;
    var generalLinks;
    var brandSection;
    var marketingSection;

    if (showMinimalLinks) {
      generalLinks = utils.getMinimalGeneralLinks(serverUrl);
    } else {
      generalLinks = utils.getGeneralLinks(serverUrl, localeInfo, helpLinks);
    }

    if (showBrand) {
      brandSection = React.createElement(Illustration, {
        type: React.createElement(BrandSuperCropIllustrationSvg, null),
        width: "100%",
        height: "auto"
      });
    }

    if (showMarketingLinks) {
      marketingSection = React.createElement(MarketingSection, {
        serverUrl: serverUrl,
        popularSearches: popularSearches,
        eventsToPlan: eventsToPlan,
        thirdFooterColumn: thirdFooterColumn,
        thirdFooterColumnName: thirdFooterColumnName,
        localeInfo: localeInfo
      });
    }

    var formattedLocales = utils.getLocales(locales);
    return React.createElement(GlobalFooter, {
      generalLinks: generalLinks,
      locales: formattedLocales,
      currentLocale: localeInfo.locale,
      onLocaleChange: onLocaleChange,
      brandSection: brandSection,
      flexibleSection: marketingSection
    });
  };

  return SiteFooter;
}(React.Component);

_defineProperty(SiteFooter, "propTypes", {
  serverUrl: PropTypes.string.isRequired,
  locales: LOCALES_ARRAY_PROP_TYPE.isRequired,
  localeInfo: LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  popularSearches: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  eventsToPlan: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumn: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumnName: PropTypes.string.isRequired,
  countries: COUNTRIES_ARRAY_PROP_TYPE.isRequired,
  helpLinks: HELP_LINKS_PROP_TYPE.isRequired,
  onLocaleChange: PropTypes.func,
  isUserAuthenticated: PropTypes.bool,
  showMinimalLinks: PropTypes.bool,
  showMarketingLinks: PropTypes.bool,
  showBrand: PropTypes.bool
});

export { SiteFooter as default };